import { t } from 'ttag'

import skillsDecoderSvg from '@h2/assets/svg/blockGraphics/skillsDecoder.svg'
import { Promotion } from '@h2/features/dashboard/promotion'

const ChooseGoalCard = () => {
  return (
    <Promotion color="blue" variant="continue">
      <Promotion.PreHeading>{t`Get Started Here`}</Promotion.PreHeading>
      <Promotion.Heading>{t`Where are you headed to?`}</Promotion.Heading>
      <Promotion.Text>{t`Whether you want to find your perfect career path, find employment, or apply for college. Setting your goal enables the CareerExplorer to guide you through the process.`}</Promotion.Text>
      <Promotion.Button href="/planning/goal">{t`Define a Goal`}</Promotion.Button>
      <Promotion.Image src={skillsDecoderSvg} />
    </Promotion>
  )
}

export { ChooseGoalCard }
